import { render } from "./HomeHcCard.vue?vue&type=template&id=3cf8c4e8&scoped=true"
import script from "./HomeHcCard.vue?vue&type=script&lang=js"
export * from "./HomeHcCard.vue?vue&type=script&lang=js"

import "./HomeHcCard.vue?vue&type=style&index=0&id=3cf8c4e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf8c4e8"]])

export default __exports__